// Flash messages.
//
// Rendered by the layout as a fixed overlay (so they never push page
// content down). Each message auto-dismisses after a few seconds and can
// be closed early via its × button. When the last message is gone the
// whole container is removed.
import { Controller } from "@hotwired/stimulus"

const DISMISS_AFTER_MS = 6000
const FADE_MS = 300

export default class extends Controller<HTMLElement> {
  static targets = ["item"]
  declare readonly itemTargets: HTMLElement[]

  private timers: number[] = []

  connect(): void {
    this.itemTargets.forEach((item) => {
      this.timers.push(window.setTimeout(() => this.remove(item), DISMISS_AFTER_MS))
    })
  }

  disconnect(): void {
    this.timers.forEach((t) => window.clearTimeout(t))
    this.timers = []
  }

  // × button on a single message.
  dismiss(event: Event): void {
    const btn = event.currentTarget as HTMLElement
    const item = btn.closest("[data-flash-target=item]") as HTMLElement | null
    if (item) this.remove(item)
  }

  private remove(item: HTMLElement): void {
    item.style.opacity = "0"
    window.setTimeout(() => {
      item.remove()
      if (this.itemTargets.length === 0) this.element.remove()
    }, FADE_MS)
  }
}
